import { AircraftBenefit, SectionBenefit } from '@app/interfaces/aircraft-benefits.interface';

export class ArCraftBenefitsModel implements AircraftBenefit {
  nid: string;
  aircraftCode: string;
  commercialName: string;
  exteriorImage: string;
  language: string;
  sections: SectionBenefit;

  constructor(raw?: Partial<AircraftBenefit & { aircraftType: string }>, language?: string) {
    if (raw) {
      this.nid = raw.nid || '';
      this.aircraftCode = raw.aircraftType || '';
      this.commercialName = raw.commercialName || '';
      this.exteriorImage = raw.exteriorImage || '';
      this.language = language || raw.language || 'en';
      this.sections = raw.sections || null;
    } else {
      this.nid = '';
      this.aircraftCode = '';
      this.commercialName = '';
      this.exteriorImage = '';
      this.language = language || 'en';
      this.sections = null;
    }
  }
}

export class ArCraftBenefits {
  private static aircraftBenefits: ArCraftBenefitsModel[] = [];

  static setAirCraftBenefits(data: ArCraftBenefitsModel[]): void {
    this.aircraftBenefits = data;
  }

  static findByAircraftCode(
    aircraftCode: string,
    language: string
  ): ArCraftBenefitsModel | undefined {
    return this.aircraftBenefits
      .filter((item) => item.language === language)
      .find((item) => item.aircraftCode === aircraftCode);
  }
}
